import { PropsWithChildren, ReactNode } from 'react'

import { inputId } from 'aem-libs-tests/src/constants/inputId'
import { createTestId } from 'aem-libs-tests/src/utility/createTestId'
import { isDefined } from 'aem-libs-ts/src/utils/common/isDefined'

import { Tip, TipProps } from '../../../../common/tip'
import * as CalcInput from '../CalcInput.styled'
import { LabelSize } from '../types'


interface InputRowProps {
  className?: string
  label?: string | ReactNode
  labelSize?: LabelSize
  tip?: TipProps
  htmlFor?: string
  testId?: string
  id?: string
}

export const InputRow = ({
  label,
  labelSize,
  className,
  tip,
  children,
  htmlFor,
  testId,
  id
}: PropsWithChildren<InputRowProps>) => {
  const usedTestId = testId ?? 'input-row'
  return (
    <CalcInput.Container className={className}>
      {isDefined(label) && (
        <CalcInput.Label htmlFor={htmlFor ?? id} id={`${id}-label`} $labelSize={labelSize} data-testid={usedTestId}>
          {label}
          {tip && <Tip {...tip} testId={createTestId(usedTestId, inputId.tip)} aria-label={`Tip: ${tip.text}`} />}
        </CalcInput.Label>
      )}
      <CalcInput.Content id={'input-row__content'} data-testid={createTestId(usedTestId, 'children')}>
        {children}
      </CalcInput.Content>
    </CalcInput.Container>
  )
}
